<!-- Two search listener approaches at the parent level:
 1): dispatch a (debounced) event on search, and then you can use that in the parent to do an api call and dynamically generate field using on:filter
 2): search prop here binded to $filter, accessible at the parent level
-->
<script lang="ts">
  import { afterUpdate, createEventDispatcher, getContext, onDestroy } from "svelte";
  import { filterKey } from "../internal/DropdownContent.svelte";
  import { focus } from "$actions/focus";
  import { DEFAULT_DEBOUNCE_MS } from "$utils/consts";
  import type { Writable } from "svelte/store";

  export let search: string = "";
  export let placeholder: string = "Search...";

  const filter = getContext<Writable<string>>(filterKey);
  let ref: HTMLInputElement;
  let timer: NodeJS.Timeout | undefined;
  let dispatch = createEventDispatcher();

  const debounce = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch("filter", $filter);
    }, DEFAULT_DEBOUNCE_MS);
  };

  // focus the input after the component is rendered
  afterUpdate(() => {
    ref.focus();
  });

  onDestroy(() => clearTimeout(timer));

  $: search = $filter;
</script>

<input
  {placeholder}
  size={placeholder.length}
  bind:this={ref}
  bind:value={$filter}
  on:input={debounce}
  on:keydown={(e) => e.key === "Enter" && dispatch("enter", search)}
  use:focus
  class="shrink-0 overflow-hidden border-0 bg-transparent px-2.5 py-2 text-sm font-normal text-neutral-500 placeholder:text-neutral-400/80 focus:outline-none dark:text-white dark:placeholder:text-neutral-500"
/>
